export const BADGE_THRESHOLDS = {
  host: [
    { level: 1, threshold: 1, name: "Mic Check", vibe: "Testing, testing..." },
    { level: 2, threshold: 10, name: "Not a Lurker", vibe: "You actually do stuff" },
    { level: 3, threshold: 50, name: "In Charge", vibe: "Running things now" },
    { level: 4, threshold: 100, name: "Calls the Shots", vibe: "Boss energy" },
    { level: 5, threshold: 250, name: "Closes Live", vibe: "Serious flex" },
  ],
  invite: [
    { level: 1, threshold: 1, name: "Not Talking to Myself", vibe: "At least one person came" },
    { level: 2, threshold: 10, name: "Brought Friends", vibe: "Social proof" },
    { level: 3, threshold: 50, name: "Brought Humans", vibe: "Verified real people" },
    { level: 4, threshold: 100, name: "Crowd Builder", vibe: "Creating momentum" },
    { level: 5, threshold: 250, name: "Fills Rooms", vibe: "You ARE the draw" },
  ],
  attend: [
    { level: 1, threshold: 1, name: "Showed Up", vibe: "Bare minimum achieved" },
    { level: 2, threshold: 10, name: "Still Showing Up", vibe: "Consistency matters" },
    { level: 3, threshold: 50, name: "Actually Listening", vibe: "Not background noise" },
    { level: 4, threshold: 100, name: "Taking Notes", vibe: "Engaged. Locked in." },
    { level: 5, threshold: 250, name: "In It to Win It", vibe: "Ride or die" },
  ],
};

export const getBadgeForCount = (category, count) => {
  const badges = BADGE_THRESHOLDS[category];
  let currentBadge = null;

  for (let i = badges.length - 1; i >= 0; i--) {
    if (count >= badges[i].threshold) {
      currentBadge = badges[i];
      break;
    }
  }

  return currentBadge;
};

export const getNextBadge = (category, count) => {
  const badges = BADGE_THRESHOLDS[category];

  for (let badge of badges) {
    if (count < badge.threshold) {
      return badge;
    }
  }

  return null; // Max level reached
};

export const getProgress = (category, count) => {
  const currentBadge = getBadgeForCount(category, count);
  const nextBadge = getNextBadge(category, count);

  if (!nextBadge) {
    return { current: currentBadge, next: null, progress: 100, remaining: 0 };
  }

  const startThreshold = currentBadge ? currentBadge.threshold : 0;
  const endThreshold = nextBadge.threshold;
  const progress = ((count - startThreshold) / (endThreshold - startThreshold)) * 100;

  return {
    current: currentBadge,
    next: nextBadge,
    progress: Math.min(progress, 100),
    remaining: endThreshold - count,
  };
};
